import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function StarPicker(props) {
    const {store, group, id, total} = props;
    const symbols = [];

    const imageSize = 24;
    const imgElem = (name, className) => {
        if (!className) className = name;
        return (<img className={className} width={imageSize} height={imageSize} src={`img/coins/${name}.svg`}/>);
    };
    const selected = store.persistStore.getScore(group, id);
    for (let i = 0; i < selected; i++) {
        symbols.push(imgElem('coin',));
    }

    let toPick = Math.min(store.persistStore.getRemainingCoins(group), total - selected);
    for (let i = 0; i < toPick; i++) {
        symbols.push(imgElem('gap'));
    }

    let length = symbols.length;
    for (let i = 0; i < total - length; i++) {
        symbols.push(imgElem('gap', 'disabled-gap'));
    }

    const onClick = (i) => {
        return () => {
            let score = i + 1;

            if (store.persistStore.getRemainingCoins(group) < (score-selected)) return;

            store.persistStore.setScore(group, id, score);
        }
    };
    return (
        <div className={'StarPicker'}>
            <div className={'symbol'} onClick={() => {
                store.persistStore.setScore(group, id, 0);
            }}><img className={(selected > 0) ? 'close' : 'close-disabled'} width={imageSize} height={imageSize}
                    src={'img/coins/close.svg'}/>
            </div>
            {symbols.map((s, i) => <div key={`${i}`} className={'symbol'} onClick={onClick(i)}>{s}</div>)}
        </div>
    );
}
StarPicker.defaultProps = {
    group: 'program',
};

export default observer(StarPicker);
